import React from 'react';
import { observer } from 'mobx-react';
import { FacilityListTemplate } from 'themes/application/facility/pages';
import { setCurrentView } from 'core/utils';
import { FacilityViewStore } from 'application/facility/stores';

@setCurrentView((rootStore) => new FacilityViewStore(rootStore), 'listViewStore')
@observer
class FacilityList extends React.Component {
    render() {
        return <FacilityListTemplate {...this.props} />
    }
}

export default FacilityList;